export const clearAllTimeouts = (timeouts: Array<NodeJS.Timeout>): void => {
  timeouts.forEach(clearTimeout);
};
